module.exports = __webpack_public_path__ + "static/media/manOnTable.3f17ffac.svg";